"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbJsonLd = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _jsonld = require("./jsonld");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A breadcrumb trail on a page indicates the page's position in the site
 * hierarchy. A user can navigate all the way up in the site hierarchy, one
 * level at a time, by starting from the last breadcrumb in the breadcrumb
 * trail.
 *
 * @remarks
 *
 * BreadCrumbJsonLd creates a
 * {@link https://schema.org/BreadcrumbList | BreadcrumbList} container item
 * that holds all elements in the list.
 *
 * ```jsx
 * import React from 'react';
 * import { BreadcrumbJsonLd } from 'gatsby-plugin-next-seo';
 *
 * export default () => (
 *   <>
 *    <h1>Breadcrumb JSON-LD</h1>
 *    <BreadcrumbJsonLd
 *      itemListElements={[
 *        {
 *          position: 1,
 *          name: 'Books',
 *          item: 'https://example.com/books',
 *        },
 *        {
 *          position: 2,
 *          name: 'Authors',
 *          item: 'https://example.com/books/authors',
 *        },
 *        {
 *          position: 3,
 *          name: 'Ann Leckie',
 *          item: 'https://example.com/books/authors/annleckie',
 *        },
 *        {
 *          position: 4,
 *          name: 'Ancillary Justice',
 *          item: 'https://example.com/books/authors/ancillaryjustice',
 *        },
 *      ]}
 *     />
 *   </>
 * );
 * ```
 * *
 */
var BreadcrumbJsonLd = function BreadcrumbJsonLd(_ref) {
  var _ref$itemListElements = _ref.itemListElements,
      itemListElements = _ref$itemListElements === void 0 ? [] : _ref$itemListElements,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$defer = _ref.defer,
      defer = _ref$defer === void 0 ? false : _ref$defer;

  var json = _objectSpread({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElements.map(function (_ref2) {
      var position = _ref2.position,
          item = _ref2.item,
          name = _ref2.name;
      return {
        '@type': 'ListItem',
        position: position,
        item: {
          '@id': item,
          name: name,
          '@type': 'Thing'
        }
      };
    })
  }, overrides);

  return /*#__PURE__*/_react["default"].createElement(_jsonld.JsonLd, {
    defer: defer,
    json: json
  });
};

exports.BreadcrumbJsonLd = BreadcrumbJsonLd;